import type { DirectoryUser } from '../../types/user';

export function formatDirectoryUserDisplayName(
  directoryUser: DirectoryUser | undefined,
  unknownUserLabel: string,
): string {
  const fullName = [
    directoryUser?.firstName?.trim(),
    directoryUser?.lastName?.trim(),
  ]
    .filter((part): part is string => Boolean(part))
    .join(' ');

  if (fullName !== '') {
    return fullName;
  }

  const username = directoryUser?.username?.trim();
  if (username) {
    return username;
  }

  return unknownUserLabel;
}

/** Up to two uppercase initials from a display name (e.g. "Jane Doe" → "JD"). */
export function formatInitials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}

/**
 * Resolve the API `userRef` for a LAC user (Keycloak UUID path param).
 * On `User` payloads, `id` is the person. `userId` is the User-row creator
 * (audit) and must not be used as the person's identity.
 * Falls back to username (`name`) only when `id` is missing.
 */
export function resolveUserRef(user: {
  id?: string | null;
  name: string;
}): string {
  const id = user.id?.trim();
  if (id) {
    return id;
  }

  return user.name.trim();
}
